<template>
  <div style="height: inherit">
    <div
      class="body-content-overlay"
      :class="{ show: isShowLeftSidebar || isShowDonViThongKeSidebar }"
      @click="isShowLeftSidebar = isShowDonViThongKeSidebar = false"
    />

    <left-sidebar
      :parent-id="code"
      :is-show-left-sidebar.sync="isShowLeftSidebar"
      :form-data="editData"
      @refetch-data="reLoadDataTable"
    />
    <don-vi-thong-ke-left-sidebar
      :parent-id="code"
      :is-show-left-sidebar.sync="isShowDonViThongKeSidebar"
      :form-data="dataTable"
      @refetch-data="reLoadDataTable"
    />

    <div v-if="code">
      <don-vi-thong-ke-data-table
        :code="code"
        :data-table="dataTable"
        :is-loaded="dataTableIsLoaded"
        @show-edit="showDonViThongKeSidebar"
        @remove-item="removeItem"
      />
    </div>
    <div v-else>
      <data-table
        :data-table="dataTable"
        :is-loaded="dataTableIsLoaded"
        @show-edit="showLeftSlidebar"
        @remove-item="removeItem"
      />
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import LayoutData from "@/layouts/LayoutData";
import {} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

import Breadcrumb from "./components/breadcrumb.vue";
import DataTable from "./components/DataTable.vue";
import DonViThongKeDataTable from "./components/DonViThongKeDataTable.vue";

import { ref, computed, watch } from "@vue/composition-api";
import store from "@/store";
import { useRouter } from "@core/utils/utils";

import { useToast } from "vue-toastification/composition";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

import {} from "@/services/api/DefaultTemplate/DonViService";

import LeftSidebar from "./components/LeftSidebar.vue";
import DonViThongKeLeftSidebar from "./components/DonViThongKeLeftSidebar.vue";

import useSetup from "./useSetup";

export default {
  directives: {
    Ripple,
  },
  components: {
    Breadcrumb,
    LeftSidebar,
    DataTable,
    DonViThongKeDataTable,
    DonViThongKeLeftSidebar,
  },
  data() {
    return {
      isWait: false,
    };
  },
  methods: {},
  setup(props, { emit }) {
    const toast = useToast();
    const { route, router } = useRouter();
    const headerData = ref(LayoutData.header.data);
    headerData.value.title = "Đơn vị thống kê";
    document.title =
      headerData.value.title + " | " + LayoutData.appInfo.data.appName;
    const code = ref(router.currentRoute.params.code);

    const isShowLeftSidebar = ref(false);
    const isShowDonViThongKeSidebar = ref(false);
    const dataTable = ref([]); //Child
    const dataTableIsLoaded = ref(false);
    const editData = ref({});

    const { donViGetInfo } = useSetup();

    const fetchData = () => {
      dataTableIsLoaded.value = true;
      // console.log("code.value", code.value);
      donViGetInfo(code.value, (response) => {
        // console.log("response", response);
        // const { info, childs, parents } = response;
        dataTable.value = response || [];
        dataTableIsLoaded.value = false;
      });
    };
    fetchData();

    const showLeftSlidebar = (data, id) => {
      isShowLeftSidebar.value = true;
      editData.value = JSON.parse(JSON.stringify(data));
    };
    const showDonViThongKeSidebar = (data, id) => {
      isShowDonViThongKeSidebar.value = true;
      editData.value = JSON.parse(JSON.stringify(data));
    };

    const removeItem = (item) => {
      var index = dataTable.value.findIndex((el) => el.id == item.id);
      if (index != -1) {
        dataTable.value.splice(index, 1);
      }
    };

    const reLoadDataTable = () => {
      fetchData();
    };

    //
    const routeParams = computed(() => route.value.params);
    watch(routeParams, () => {
      code.value = router.currentRoute.params.code;
      fetchData();
    });

    return {
      code,
      // breadcrumbInfo,
      dataTable,
      dataTableIsLoaded,
      editData,

      isShowLeftSidebar,
      isShowDonViThongKeSidebar,
      showDonViThongKeSidebar,
      showLeftSlidebar,
      reLoadDataTable,
      removeItem,
    };
  },
};
</script>

<style lang="scss" scoped></style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";
</style>
